export const clientSqlDefaultLimit = 20;
